/* ET - Comparison Table
   - Equalises row / header / footer heights across the labels column and every product column so everything lines up,
     regardless of text wrapping. Desktop uses a real CSS grid, so this only runs at the mobile breakpoint.
   - Drives the custom mobile scrollbar (progress + drag).
   - Adds the current product to cart and redirects to the cart.

   Ported from WASDROOM/test/pdp_007. Init is scoped per section root, so several tables can coexist on one page. */

(function () {
  'use strict';

  /* Keep in sync with the mobile breakpoint in et-comparison-table.css. */
  var MOBILE_QUERY = '(max-width: 749px)';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function syncGroup(els) {
    if (!els.length) return;
    els.forEach(function (el) {
      el.style.minHeight = '';
    });
    var max = 0;
    els.forEach(function (el) {
      max = Math.max(max, el.offsetHeight);
    });
    els.forEach(function (el) {
      el.style.minHeight = max + 'px';
    });
  }

  function clearHeights(root) {
    qsa(root, '[data-cmp-row], [data-cmp-head], [data-cmp-foot]').forEach(function (el) {
      el.style.minHeight = '';
    });
  }

  function syncHeights(root) {
    /* Group the value/label rows by their shared row index. */
    var byIndex = {};
    qsa(root, '[data-cmp-row]').forEach(function (el) {
      el.style.minHeight = '';
      var i = el.getAttribute('data-cmp-row');
      (byIndex[i] = byIndex[i] || []).push(el);
    });
    Object.keys(byIndex).forEach(function (i) {
      syncGroup(byIndex[i]);
    });

    syncGroup(qsa(root, '[data-cmp-head]'));
    syncGroup(qsa(root, '[data-cmp-foot]'));
  }

  function initScrollbar(root) {
    var scroller = qs(root, '[data-cmp-scroller]');
    var bar = qs(root, '[data-cmp-scrollbar]');
    if (!scroller || !bar) return;
    var thumb = qs(bar, '.et-cmp__scrollbar-thumb');
    if (!thumb) return;

    function update() {
      var sw = scroller.scrollWidth;
      var cw = scroller.clientWidth;
      var maxScroll = sw - cw;
      if (maxScroll <= 1) {
        bar.style.visibility = 'hidden';
        return;
      }
      bar.style.visibility = '';
      var trackW = bar.clientWidth;
      var thumbW = Math.max(48, Math.round((trackW * cw) / sw));
      var left = (scroller.scrollLeft / maxScroll) * (trackW - thumbW);
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + left + 'px)';
    }

    scroller.addEventListener('scroll', update, { passive: true });

    /* Drag the thumb to scroll. */
    var dragging = false;
    var startX = 0;
    var startLeft = 0;

    function pointerDown(e) {
      dragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      startLeft = thumb.offsetLeft;
      if (e.cancelable) e.preventDefault();
      document.addEventListener('mousemove', pointerMove);
      document.addEventListener('mouseup', pointerUp);
      document.addEventListener('touchmove', pointerMove, { passive: false });
      document.addEventListener('touchend', pointerUp);
    }

    function pointerMove(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      var trackW = bar.clientWidth;
      var thumbW = thumb.offsetWidth;
      var newLeft = Math.max(0, Math.min(trackW - thumbW, startLeft + (x - startX)));
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      scroller.scrollLeft = (newLeft / (trackW - thumbW)) * maxScroll;
      if (e.cancelable) e.preventDefault();
    }

    function pointerUp() {
      dragging = false;
      document.removeEventListener('mousemove', pointerMove);
      document.removeEventListener('mouseup', pointerUp);
      document.removeEventListener('touchmove', pointerMove);
      document.removeEventListener('touchend', pointerUp);
    }

    thumb.addEventListener('mousedown', pointerDown);
    thumb.addEventListener('touchstart', pointerDown, { passive: false });

    root.__cmpUpdateBar = update;
    update();
  }

  function initCart(root) {
    var addUrl = root.getAttribute('data-cart-add-url');
    var cartUrl = root.getAttribute('data-cart-url');
    qsa(root, '[data-cmp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.classList.add('is-loading');
        var xhr = new XMLHttpRequest();
        xhr.open('POST', addUrl + '.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) window.location.href = cartUrl;
        };
        xhr.send(JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }));
      });
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function init(root) {
    if (!root || root.__cmpInit) return;
    root.__cmpInit = true;

    initCart(root);
    initScrollbar(root);

    var mobile = window.matchMedia(MOBILE_QUERY);

    function relayout() {
      /* Desktop uses a real CSS grid (rows already align); only the mobile static-labels + scroller layout needs
         JS to equalise row heights. */
      if (mobile.matches) syncHeights(root);
      else clearHeights(root);
      if (root.__cmpUpdateBar) root.__cmpUpdateBar();
    }

    relayout();

    /* Re-run once images settle (they affect header height). */
    qsa(root, '.et-cmp__img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', relayout);
    });

    window.addEventListener('resize', debounce(relayout, 150));
    window.addEventListener('load', relayout);
  }

  function boot() {
    qsa(document, '[data-cmp-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor support. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cmp-root]');
    if (root) init(root);
  });
})();
